import { render, staticRenderFns } from "./ActivityDetailsModal.vue?vue&type=template&id=0183073d&scoped=true"
import script from "./ActivityDetailsModal.vue?vue&type=script&lang=js"
export * from "./ActivityDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0183073d",
  null
  
)

export default component.exports